import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './indicator.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const IndicatorDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const indicatorEntity = useAppSelector(state => state.indicator.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="indicatorDetailsHeading">
          <Translate contentKey="fleetSenseApp.indicator.detail.title">Indicator</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{indicatorEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.indicator.name">Name</Translate>
            </span>
          </dt>
          <dd>{indicatorEntity.name}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="fleetSenseApp.indicator.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{indicatorEntity.unit}</dd>
          <dt>
            <span id="aggregateMethod">
              <Translate contentKey="fleetSenseApp.indicator.aggregateMethod">Aggregate Method</Translate>
            </span>
          </dt>
          <dd>{indicatorEntity.aggregateMethod}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.indicator.description">Description</Translate>
            </span>
          </dt>
          <dd>{indicatorEntity.description}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="fleetSenseApp.indicator.type">Type</Translate>
            </span>
          </dt>
          <dd>{indicatorEntity.type}</dd>
        </dl>
        <Button tag={Link} to="/indicator" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/indicator/${indicatorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IndicatorDetail;
